import React from 'react'
import useFormValue from '../../hooks/useFormValue';
import { MessageContactFormStyled } from '../../styledComponents/MessageContacFormStyled';

export function ContactForm() {

    const { values, handleStateForm } = useFormValue()
    const handleSubmit = (event) => {
        event.preventDefault()
        const url =
            "https://r1tbpzzkgh.execute-api.us-west-2.amazonaws.com/production/mensajes";
        console.log(values);


    }

    console.log(values);

    return (
        <form
            className="container__contact--form"
            onSubmit={handleSubmit}
        >
            <h3 className="contact--from__h3">Escríbenos</h3>
            <p className="contact--from__p">¡Seguro podemos asesorarte!</p>
            <div className="form-group">
                <input
                    id="nombre"
                    name="nombre"
                    className="contact--from__input"
                    value={values.nombre}
                    onChange={handleStateForm}
                    placeholder="Nombre"
                    type="text"
                    maxLength="20"
                    required
                />
            </div>
            <div className="form-group">
                <input
                    id="empresa"
                    name="empresa"
                    className="contact--from__input"
                    value={values.empresa}
                    onChange={handleStateForm}
                    placeholder="Empresa"
                    type="text"
                    maxLength="20"
                    required
                />
            </div>

            <div className="form-group">
                <input
                    id="telefono"
                    name="telefono"
                    className="contact--from__input"
                    value={values.telefono}
                    onChange={handleStateForm}
                    placeholder="Numero telefónico"
                    pattern="[0-9]{10}"
                    type="tel"
                    maxLength="20"
                    required
                />
            </div>
            <div className="form-group">
                <input
                    id="correo"
                    name="correo"
                    className="contact--from__input"
                    value={values.correo}
                    onChange={handleStateForm}
                    placeholder="E-mail"
                    type="email"
                    maxLength="50"
                    required
                />
            </div>





            <div className="form-group">
                <input
                    id="mensaje"
                    name="mensaje"
                    className="contact--from__input"
                    value={values.mensaje}
                    onChange={handleStateForm}
                    placeholder="Mensaje"
                    type="text"
                    maxLength="254"
                    required
                />
            </div>
            <button
                type="submit"
                className="btn contact--from__btn"
            >
                Enviar
            </button>
            <MessageContactFormStyled id="con-msg">
                <div id="msg">
                    <h2>
                        Gracias, nos comunicaremos lo más pronto posible
                        contigo.
                    </h2>
                </div>
            </MessageContactFormStyled>
        </form>
    )
}
